var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditcrm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.20074 11.0346H11.2007M0.800781 11.0346L3.71144 10.4481C3.86596 10.417 4.00783 10.3409 4.11926 10.2294L10.635 3.71007C10.9474 3.3975 10.9472 2.89084 10.6346 2.57853L9.25429 1.19981C8.94176 0.887637 8.43536 0.887849 8.12309 1.20029L1.60662 7.72032C1.49541 7.8316 1.41948 7.97318 1.38832 8.12738L0.800781 11.0346Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditcrm);
export default __webpack_public_path__ + "static/media/Editcrm.56d3014ef997ac40522849f46fd3165b.svg";
export { ForwardRef as ReactComponent };